export const DEFAULT_FLAGS=Object.freeze({
  recipes:false,
  planner:false,
  dymek:false,
  dymekProvider:false,
  sharing:false,
  premium:false,
  community:false,
  smokehouseSync:false,
  journalSync:false
});

export function resolveFeatureFlags(remote={},defaults=DEFAULT_FLAGS){
  const out={};
  for(const [key,fallback] of Object.entries(defaults))out[key]=typeof remote?.[key]==='boolean'?remote[key]:fallback;
  return Object.freeze(out);
}
